import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {filter} from 'rxjs/operators';
import {FadeInOutAnimation} from '@helpers/animations/fadeInOut.animation';
import {ApplicationConfigService} from '@services/application-config.service';
import {environment} from '@environments/environment';
import {DropdownDirective} from '@lab365/common';

@Component({
    selector: 'app-update-caller',
    templateUrl: './update-caller.component.html',
    styleUrls: ['./update-caller.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        FadeInOutAnimation,
    ]
})

export class UpdateCallerComponent implements OnInit, OnDestroy {

    public active = false;

    public updatePageUrl = environment.updatePageUrl;

    private appVersion: string;

    @ViewChild(DropdownDirective) private dropdown: DropdownDirective;

    constructor(
        private appConfig: ApplicationConfigService,
        private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.appConfig.appVersion$.pipe(
            untilDestroyed(this),
            filter(v => this.appVersion !== v)
        ).subscribe((version) => {
            if (!this.appVersion) {
                this.appVersion = version;
                return;
            }

            this.active = true;
            this.appVersion = version;

            if (this.dropdown) {
                this.dropdown.open();
            }

            this.cd.detectChanges();
        });
    }

    updatePage() {
        window.location.reload();
    }

    ngOnDestroy(): void {

    }
}
